import { useEffect, useState } from 'react';
import { ProfileLogo, Text } from 'src/components';
import { Select } from 'antd';
import { useDispatch } from 'react-redux';
import { Bars } from 'react-loader-spinner';
import './TemplatesExchangeModal.scss';
import DotPhraseModal from './DotPhraseModal';
import { getDotPhraseByIdAction } from '../../store/actions/templatesexchange.action';
import { BackIconMobile } from 'src/icons';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';
// TODO: fix unused state

const DotPhrase = ({
  setDotPhraseComponent,
  dotPhraseList,
  templateOverridesList,
}) => {
  const dispatch = useDispatch();
  const [, setAuraComponent] = useState(false);
  const [dotPhraseOpen, setdotPhraseOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedName, setSelectedName] = useState('');

  const [dotPhraseOverrideId, setdotPhraseOverrideId] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    if (dotPhraseList?.length > 0) {
      setLoading(false);
    }
  }, [dotPhraseList]);

  useEffect(() => {
    analytics.track('Viewed Dot Phrases Exchange', { email: user?.email });
  }, []);

  const handleBackButton = () => {
    analytics.track('Clicked Back Button In Dot Phrases Exchange', {
      email: user?.email,
    });
    setAuraComponent(true);
    setDotPhraseComponent(false);
  };

  const handleDotPhraseOpen = (dot_phrase_overrides_id) => {
    analytics.track('Clicked Dot Phrase Tile', { email: user?.email });
    setdotPhraseOverrideId(dot_phrase_overrides_id);
    dispatch(getDotPhraseByIdAction(dot_phrase_overrides_id, setdotPhraseOpen));
  };

  const dotPhraseFields =
    dotPhraseList?.map((dot_phrase) => ({
      id: dot_phrase?.dot_phrase?.dot_phrase_overrides_id,
      name: dot_phrase?.dot_phrase?.title,
      detail: 'Section header',
      users: dot_phrase?.user_count,
      sharedTemp: dot_phrase?.practitioner_dot_phrases_count,
      practitionerName: dot_phrase?.practitioner_name,
      phrase: dot_phrase?.dot_phrase?.phrase,
      template: dot_phrase?.dot_phrase?.template,
    })) || [];

  const uniquePractitionerNames = [
    ...new Set(dotPhraseFields.map((template) => template.practitionerName)),
  ];

  // Filter function
  const filteredDotPhraseFields = dotPhraseFields.filter(
    (template) =>
      selectedName === 'All' ||
      selectedName === '' ||
      template.practitionerName === selectedName
  );

  if (loading) {
    return (
      <div className="page-wrapper flex justify-center items-center absolute inset-0">
        <div>
          <Bars
            height="25"
            width="25"
            color="#00D090"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      </div>
    );
  }

  const truncateString = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + '...';
    } else {
      return str;
    }
  };

  const formatTemplate = (value) => {
    return typeof value === 'string' ? value : JSON.stringify(value, null, 2);
  };

  return (
    <div className="dotphrase">
      <div className="flex gap-4 px-10 relative z-20">
        <div className="text-4xl mt-2">
          <BackIconMobile onClick={handleBackButton} />
        </div>
        <div className="flex flex-col gap-2 justify-center">
          <div className="text-4xl text-left text-black font-bold ">
            Dot phrases{' '}
          </div>
          <Select
            style={{
              width: 200,
            }}
            dropdownStyle={{
              zIndex: 999999999,
            }}
            placeholder="Filter by practitioner"
            onChange={(value) => setSelectedName(value)}
            options={[
              { value: 'All', label: 'All' }, // Add "All" option
              ...uniquePractitionerNames.map((name) => ({
                value: name,
                label: name,
              })),
            ]}
          />
        </div>
      </div>
      {filteredDotPhraseFields?.length === 0 ? (
        <div className=" absolute inset-0 flex justify-center items-center z-10">
          <div className="bg-white p-10 rounded-lg shadow-lg text-base font-medium text-gray">
            Custom templates from all users will appear on this page
          </div>
        </div>
      ) : (
        <div className="grid grid-rows-1 lg:grid-cols-2 gap-x-24 gap-y-5 px-10 mt-5">
          {filteredDotPhraseFields.map((item, i) => {
            const id = item.id;
            const heading = item.name;
            const user = item.users;
            const share = item.sharedTemp;
            const name = item.practitionerName;
            const phrase = item.phrase;
            const template = item.template;
            const nameWithoutTitle = item.practitionerName?.replace('Dr. ', '');

            return (
              <div key={i} className="pb-2 ">
                <div className="card h-72 bg-white border-2 shadow-xl border-transparent rounded-xl">
                  <div
                    className="card-title relative text-base text-black font-medium text-center border-transparent shadow-md rounded-xl p-4 m-3 border-2"
                    style={{
                      backgroundImage:
                        'linear-gradient(to right, #ecf9ff, #ebf8fe, #e9f7fe, #e8f6fd, #e7f5fd, #e7f5fd, #e7f5fd, #e7f5fd, #e8f6fd, #e9f7fe, #ebf8fe, #ecf9ffc2)',
                    }}
                  >
                    <div className="lg:justify-center text-wrap w-1/2 lg:w-full justify-start">
                      {truncateString(heading, 25)}
                    </div>
                    <span
                      className="text-sm text-[#ff6f00] bg-[#ffe1ca] absolute top-2 right-2 flex items-center justify-center rounded-full h-8 px-3 cursor-pointer"
                      onClick={() => handleDotPhraseOpen(id)}
                    >
                      Get dot phrase
                    </span>
                  </div>

                  {!phrase == '' || !template == '' ? (
                    <div className="pl-3 cursor-pointer">
                      <div
                        className="card-text cursor-pointer px-4 pt-2"
                        onClick={() => handleDotPhraseOpen(id)}
                      >
                        <div className="flex justify-between items-center">
                          <h4 className="text-md font-bold text-black text-right">
                            {phrase}
                          </h4>
                          <div className="text-sm text-right">
                            <p>
                              {user} {user === 1 ? 'user' : 'users'}
                            </p>
                          </div>
                        </div>
                        <div className="text-sm pt-2 h-[9rem] overflow-y-auto  text-black">
                          <p>{formatTemplate(template)}</p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="cursor-auto text-center text-base font-medium mt-[72px]">
                      No dot phrase available
                    </div>
                  )}
                </div>
                <div
                  className="ant-dropdown-link"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div className="profile-wrapper flex items-center pt-3 gap-1">
                    <ProfileLogo
                      getAllTemplatesExchangeList={templateOverridesList}
                      name={nameWithoutTitle}
                      className="profile-popover-logo mr-1 sm:mr-2 lg:mr-3"
                      practitioner_name={name}
                    />
                    <Text
                      type={'span'}
                      className="user-name mt-4 mr-1 sm:mr-2 lg:mr-3 text-black font-medium"
                    >
                      <div id="dot_phrase_owner">{name}</div>
                      <div className="text-xs text-gray-500">
                        {share} {share === 1 ? 'dot phrase' : 'dot phrases'}{' '}
                        shared
                      </div>
                    </Text>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <DotPhraseModal
        isOpen={dotPhraseOpen}
        setIsOpen={setdotPhraseOpen}
        dotPhraseOverrideId={dotPhraseOverrideId}
      />
    </div>
  );
};

export default DotPhrase;
